import React from "react";
import "./how.css";
import { RiPhoneCameraFill } from "react-icons/ri";
import Arrow from "../../Media/arroww.png";

export default function How() {
  return (
    <div className="how">
      <img className="arrow arrow-1" src={Arrow} alt="dotted arrow" loading="lazy" decoding="async" />
      <img className="arrow arrow-2" src={Arrow} alt="dotted arrow" loading="lazy" decoding="async" />
      <h6 className="small-header">Our Process</h6>
      <h3>How this Works</h3>
    
      <div className="how-boxes">
        <div className="how-box">
          <div className="how-icon">
            <RiPhoneCameraFill />
          </div>
          <h4>Consultation & Discovery</h4>
          <p>
            We begin by understanding you—your vision, preferences, and
            lifestyle. This step is about uncovering the essence of your style
            so we can translate it into thoughtful, wearable art.
          </p>
        </div>
        <div className="how-box">
          <div className="how-icon center">
            <RiPhoneCameraFill />
          </div>
          <h4>Design & Material Selection</h4>
          <p>
            Our designers craft original concepts based on your brief. We guide
            you through fabric choices, cuts, and colors that not only enhance
            your individuality but also ensure comfort and elegance.
          </p>
        </div>
        <div className="how-box">
          <div className="how-icon">
            <RiPhoneCameraFill />
          </div>
          <h4>Tailoring & Final Fittings</h4>
          <p>
            Each piece is handcrafted by our expert tailors with precision.
            Multiple fittings ensure every detail is perfected, delivering
            garments that fit flawlessly and feel uniquely yours.
          </p>
        </div>
      </div>
    </div>
  );
}
